// Angular Imports
import { NgModule } from '@angular/core';

// This Module's Components
import { IssuanceLookupComponent } from './issuance-lookup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BizDatatableModule } from '../biz-datatable/biz-datatable.module';
import { PagesContainersModule } from '../../../../../containers/pages/pages.containers.module';
import { BizDropdownModule } from '../biz-dropdown/biz-dropdown.module';

@NgModule({
    imports: [
        FormsModule, ReactiveFormsModule, CommonModule, BizDatatableModule,  BizDropdownModule
    ],
    declarations: [
        IssuanceLookupComponent,
    ],
    exports: [
        IssuanceLookupComponent,
    ]
})
export class IssuanceLookupModule {

}
